import React from "react";
import styles from "./PrintmasteringAndPackaging.module.scss";

import { SpatialCarousel } from "@src/lms/jelly/extensions/layouts";
import { messages } from "../Workflow.messages";
import { useIntl } from "react-intl";
import { useUi } from "@jelly/lesson";

export const PrintmasteringAndPackaging: React.FC = () => {
  const { formatMessage } = useIntl();
  const ui = useUi();

  return (
    <div className={styles.container}>
      {/*// @ts-expect-error We cannot override layouts using Contexts :/ */}
      <SpatialCarousel showBreadcrumbs>
        {[
          <div key={1} className={styles.carouselItem}>
            <h3 className={styles.title}>{formatMessage(messages.printmasteringAndPackagingTitle1)}</h3>
            <ui.Scrollbars>
              <p
                dangerouslySetInnerHTML={{ __html: formatMessage(messages.printmasteringAndPackagingDescription1) }}
              ></p>
            </ui.Scrollbars>
          </div>,
          <div key={2} className={styles.carouselItem}>
            <h3 className={styles.title}>{formatMessage(messages.printmasteringAndPackagingTitle2)}</h3>
            <ui.Scrollbars>
              <p
                dangerouslySetInnerHTML={{ __html: formatMessage(messages.printmasteringAndPackagingDescription2) }}
              ></p>
            </ui.Scrollbars>
          </div>,
        ]}
      </SpatialCarousel>
    </div>
  );
};
